import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["hint"];

  verifyContractAddress(e) {
    const addressType = e.target.dataset.addressType;

    if (addressType === "evm") {
      this._verifyEthAddress(e.target.value, e.target.dataset.evmMessage);
    } else if (addressType === "solana") {
      this._verifySolanaAddress(e.target.value, e.target.dataset.solanaMessage);
    }
  }

  _verifyEthAddress(value, message) {
    this._verifyAddress((value.length < 42 || value.slice(0, 2) !== "0x"), message);
  }

  _verifySolanaAddress(value, message) {
    this._verifyAddress((value.length < 32 || value.length > 44), message);
  }

  _verifyAddress(condition, message) {
    if (condition) {
      this.hintTarget.innerText = message;
    } else {
      this.hintTarget.innerText = "";
    }
  }
}
